import { render, staticRenderFns } from "./ranking-list.vue?vue&type=template&id=73aac6bc&scoped=true&"
import script from "./ranking-list.vue?vue&type=script&lang=js&"
export * from "./ranking-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aac6bc",
  null
  
)

export default component.exports